.heading {
  margin-block-end: var(--space-4);
}

/*
 * Title and rule. `contracts/DESIGN-TOKENS.md` § Shared component patterns rules a heading
 * *underneath* — 2px brass, 10px below the baseline — rather than opening it with a hairline
 * above, so a section reads as part of the desk's own furniture rather than as a new page.
 */
.titleRow {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2) var(--space-4);
  padding-block-end: 0.625rem;
  border-block-end: 2px solid var(--brass-rule);
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.01em;
}

.meta {
  margin: 0;
  color: var(--text-muted);
  font-size: 0.8125rem;
}

.description {
  margin: 0.625rem 0 0;
  max-inline-size: var(--measure);
  color: var(--text-muted);
  font-size: 0.84375rem;
  line-height: var(--leading-normal);
}
